import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
  PageEvent,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { FormControl } from "@angular/forms";
import * as moment from "moment";

@Component({
  selector: "app-pl-competition-statment",
  templateUrl: "./pl-competition-statment.component.html",
  styleUrls: ["./pl-competition-statment.scss"],
})
export class PLCompetitionStatmentComponent implements OnInit {
  selected: any = {
    startDate: new Date().setHours(0, 0, 0, 0),
    endDate:
      Number(new Date().setHours(23, 59, 59).toString().slice(0, 10)) * 1000,
  };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  competitionLevelList = new MatTableDataSource<any>();
  ProviderId = new FormControl([]);
  providers: any = [];
  sportId: string = "";
  competitionId: string = "";
  competitionLevelListDisplayedSportColumns: string[] = [
    "competition_name",
    "event_name",
    "profit_loss",
  ];
  userId: string;
  userName: string = "";
  OperatorId: string = "all";
  page = 1;
  pageSize = 10;
  orgPageSize = 10;
  length: any = 0;
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  endDate: any;
  startDate: any;
  origin = [];
  category = "";
  subProvider = "";
  dropdownSettings: any = {};
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  constructor(
    private appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    // this.sportId = this.activatedRoute.snapshot.params.sportId;
    this.providers = [ "Exchange" , "SportsBook"
      // { ProviderName: "Exchange", ProviderId: "Exchange" },
      // { ProviderName: "SportsBook", ProviderId: "SportsBook" },
    ];
    this.competitionId = this.activatedRoute.snapshot.params.competitionId;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.OperatorId = params.operatorId;
      this.ProviderId.setValue([params["providerId"]]);
      this.userId = params["userId"];
      this.userName = params["userName"];
      this.sportId = params["sportId"];
      this.origin = params["origin"];
      this.category = params["category"];
      this.subProvider = params["subProvider"];
      this.selected = {
        startDate:
          params.startTime !== "0"
            ? new Date(params.startTime * 1000)
            : new Date(),
        endDate:
          params.endTime !== "0" ? new Date(params.endTime * 1000) : new Date(),
      };
    });

    if (this.ProviderId.value[0]) {
      this.onSelectedProvider(this.ProviderId.value[0]);
    } else {
      this.onSelectedProvider("Exchange");
    }
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // getOurProviders() {
  //   try {
  //     this.appService.getOurProviders().subscribe((res) => {
  //       if (res.status === "RS_OK") {
  //         this.providers = res.providers;
  //       } else {
  //         if (res.errorDescription === "Invalid Token!") {
  //           sessionStorage.clear();
  //           this.router.navigateByUrl("/login");
  //         }
  //       }
  //     });
  //   } catch (err) {}
  // }

  goToComponentEvent(data): void {
    this.router.navigate(
      [
        `reports/pl-statment/${this.sportId}/${data.competitionId}/${data.eventId}`,
      ],
      {
        queryParams: {
          providerId: this.ProviderId.value[0],
          userId: this.userId ? this.userId : "",
          userName: this.userName ? this.userName : "",
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          operatorId: this.OperatorId !== "all" ? this.OperatorId : "",
          startTime:
            this.selected.startDate !== null
              ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
              : 0,
          endTime:
            this.selected.endDate !== null
              ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
              : 0,
        },
      }
    );
  }

  goBackToSportPL = () => {
    this.router.navigate([`reports/pl-statment/${this.sportId}`], {
      queryParams: {
        providerId: this.ProviderId.value[0],
        userId: this.userId ? this.userId : "",
        userName: this.userName ? this.userName : "",
        operatorId: this.OperatorId !== "all" ? this.OperatorId : "",
        sportId: this.sportId,
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        startTime:
          this.selected.startDate !== null
            ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        endTime:
          this.selected.endDate !== null
            ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
      },
    });
  };

  goBackToUserPL = () => {
    this.router.navigate(["/reports/pl-statment"]);
  };

  onSelectedProvider = (pid) => {
    this.ProviderId.setValue([pid]);
    this.getReportData();
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.startDate !== null) {
      this.getReportData();
    }
  };

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getReportData();
  }

  getReportData = () => {
    if (this.ProviderId.value[0] !== "all") {
      try {
        let filters = {
          sportId: this.sportId,
          providerId: this.ProviderId.value[0],
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          operatorId: this.OperatorId !== "all" ? this.OperatorId : "",
          startTime:
            this.selected.startDate !== null
              ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
              : 0,
          endTime:
            this.selected.endDate !== null
              ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
              : 0,
          competitionId: this.competitionId,
          userId: this.userId ? this.userId : null,
          pageSize: this.orgPageSize,
          page: this.page,
        };
        this.appService.getCompetitionPLData(filters).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.competitionLevelList = new MatTableDataSource<any>(
              res.competitionPnLReport
            );
            if (this.page == 1) {
              this.length = res.totalBets;
            } else {
              this.paginator.length = this.length;
            }
          }
        });
      } catch (err) {}
    }
  };
}
